import { Dropdown, Input, Tooltip } from "antd";
import {
  ArrowUpDown,
  CircleX,
  Filter,
  ListFilter,
  Plus,
  RefreshCcw,
  Search,
} from "lucide-react";
import React from "react";

function StudentsSearchSec({
  studentsData,
  setCreateBatchFlag,
  setRefressGetApi,
  searchValue,
  setSortBy,
  sortBy,
  sortItems,
  searchText,
  setSearchText,
  setSearchValue,
  refreshApis,
}) {
  return (
    <div className="">
      <div className="flex justify-between mb-3 gap-2 flex-wrap">
        <div className="flex gap-x-[.65rem] gap-y-2 items-center flex-wrap">
          <div>
            <Input
              prefix={<Search size={15} />}
              placeholder="Search students..."
              suffix={
                searchText || searchValue ? (
                  <button
                    type="button"
                    onClick={() => {
                      setSearchText("");
                      setSearchValue("");
                    }}
                    className="flex items-center justify-center text-gray-500 hover:text-gray-700"
                  >
                    <CircleX size={15} />
                  </button>
                ) : null
              }
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              onPressEnter={(e) => setSearchValue(e.target.value)}
            />
          </div>
          {/* <button className="flex gap-x-[6px] items-center border-[1px] border-gray-300 rounded-md px-3 py-[5px] text-[.85rem] text-[#344054]">
            <ListFilter size={14} />
            Filter
          </button> */}

          <Dropdown
            menu={{
              // items: sortItems,
              items: sortItems?.map((item) => ({
                ...item,
                className:
                  sortBy === item.key
                    ? "!bg-orange-50 !text-[#DC6803] font-semibold"
                    : "",
              })),
              selectedKeys: [sortBy],
              onClick: ({ key }) => {
                setSortBy(key);
              },
            }}
            trigger={["click"]}
          >
            <button className="flex gap-x-[6px] items-center border-[1px] border-gray-300 rounded-md px-3 py-[5px] text-[.85rem] text-[#344054]">
              <ArrowUpDown size={14} />
              Sort by
            </button>
          </Dropdown>
          <Tooltip
            overlayInnerStyle={{
              backgroundColor: "black",
              borderRadius: 8,
              fontSize: ".85rem",
              padding: "6px 10px",
            }}
            title="Refresh Table"
          >
            <button className="ml-1" onClick={() => refreshApis()}>
              <RefreshCcw color="#344054" size={19} />
            </button>
          </Tooltip>
        </div>
        {/* <div className="flex gap-x-3 gap-y-2 items-center flex-wrap">
          <button
            onClick={() => setCreateBatchFlag(true)}
            className="btn-orange flex gap-[.3rem] items-center rounded-lg px-3 py-[.35rem] font-medium text-[.82rem]"
          >
            <Plus size={14} color="black" /> Add Student
          </button>
        </div> */}
      </div>
      {/* <StudentsTable response={response} /> */}
    </div>
  );
}

export default StudentsSearchSec;
